/** Runtime handle to the live Photorealistic tiles group (Three.js Object3D). */

let tilesGroup = null;

export function setPhotorealisticTilesGroup(group) {
  tilesGroup = group || null;
}

export function getPhotorealisticTilesGroup() {
  return tilesGroup;
}
